export default "__VITE_ASSET__7b4d6991__"